/*
  HO-CUSTOM: Hydro Oasis custom front-end scripts (the megamenu click guard, a11y fixers, cart:updated fetch
  wrapper, free-shipping text, variant-selects patch, pre-order ETA, emoji mascots, ...).
  HO-PERF: these were 9 inline <script> blocks at the end of every page (snippets/hydro-oasis-custom-scripts.liquid,
  ~21 KB re-sent with each HTML response). They now live in this cached file, loaded by snippets/ho-custom-head.liquid
  as the FIRST deferred script in <head>: it still runs before every theme bundle and section script, so the fetch
  wrapper and the variant-selects patch are in place before base.js and before any cart action. The blocks keep their
  order; each is wrapped in try/catch so one failing block cannot stop the next (they used to be separate scripts).
  The only Liquid values (free-shipping threshold, display_currency) come from window.hoFreeShippingThreshold /
  window.hoDisplayCurrency, set inline in ho-custom-head.
*/

/* 1. HO-CUSTOM: the megamenu trigger is now a real <a href> for SEO crawlability. Preserve click-to-open by preventing navigation on a plain left-click (the toggletip engine still toggles the menu); modified clicks (new tab/window) still navigate. */
try {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.main-nav-item a[data-tooltip-trigger][href]');
    if (!trigger) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault(); // capture phase: runs before the toggletip engine's stopPropagation, so the menu still toggles but the page doesn't navigate
  }, true);
} catch (e) { if (window.console) console.error(e); }

/* 2. HO-CUSTOM: repair accessibility when the affected component changes. Discover late/replaced
   widgets from added subtrees, not startup polling; keep animation style/class changes out of the
   document observer. Guard attribute writes so scoped observer deliveries converge. */
try {
  (function () {
    var controls = '.swiper-button-next, .swiper-button-prev, .swiper-button-thumbs-next, .swiper-button-thumbs-prev, [aria-controls^="swiper-wrapper-"]';
    var judgeRoots = '.jdgm-widget, .jdgm-testimonials-container, .jdgm-carousel';
    var candidates = 'swiper-container, .swiper, .jdgm-carousel-item, iframe, #mini-cart, #ho-mini-cart-empty-tmpl, ' + judgeRoots + ', ' + controls;
    var watchedControls = new WeakSet(), watchedSwipers = new WeakSet();
    var watchedSlides = new WeakSet(), watchedFrames = new WeakSet();
    var watchedJudgeRoots = new WeakSet();
    var watchedDrawers = new WeakSet(), watchedForms = new WeakSet();

    function fixSwiperControl(btn) {
      var id = btn.getAttribute('aria-controls');
      if (!id || id.indexOf('swiper-wrapper-') !== 0 || document.getElementById(id)) return;
      var c = btn.closest('swiper-container, .swiper');
      var w = c && c.querySelector('.swiper-wrapper');
      if (w && !w.id) { w.id = id; }
      else if (w || !c || (c.shadowRoot && c.shadowRoot.querySelector('.swiper-wrapper')) || (c.swiper && c.swiper.initialized)) {
        // An IDREF cannot cross into the Swiper web component's shadow DOM. Its aria-label still names
        // the control. Keep a not-yet-rendered light-DOM wrapper pending until its async init/insert.
        btn.removeAttribute('aria-controls');
      }
    }
    function fixSwiperScope(scope) {
      scope.querySelectorAll('[aria-controls^="swiper-wrapper-"]').forEach(fixSwiperControl);
    }
    function watchControl(btn) {
      if (!watchedControls.has(btn)) {
        watchedControls.add(btn);
        new MutationObserver(function () { if (btn.isConnected) fixSwiperControl(btn); })
          .observe(btn, { attributes: true, attributeFilter: ['aria-controls'] });
      }
      fixSwiperControl(btn);
    }
    function watchSwiper(c) {
      if (!watchedSwipers.has(c)) {
        watchedSwipers.add(c);
        new MutationObserver(function (records) {
          if (!c.isConnected) return;
          var changedControls = new Set(), wrapperChanged = false;
          records.forEach(function (record) {
            if (record.attributeName === 'aria-controls') changedControls.add(record.target);
            else if (record.target.matches('.swiper-wrapper')) wrapperChanged = true;
          });
          // Swiper can update the wrapper ID and each control several times during one init.
          // The current wrapper state needs one scope repair, which also covers its descendants.
          if (wrapperChanged) fixSwiperScope(c);
          changedControls.forEach(function (btn) {
            // A control can move to another component before this queued delivery, or be the host.
            if (btn.isConnected && (!wrapperChanged || btn === c || !c.contains(btn))) fixSwiperControl(btn);
          });
        }).observe(c, { subtree: true, attributes: true, attributeFilter: ['aria-controls', 'id'] });
      }
      fixSwiperScope(c);
    }
    function fixHiddenSlide(el) {
      var hidden = el.getAttribute('aria-hidden') === 'true';
      if (hidden && !el.hasAttribute('inert')) el.setAttribute('inert', '');
      else if (!hidden && el.hasAttribute('inert')) el.removeAttribute('inert');
    }
    function watchSlide(el) {
      if (!watchedSlides.has(el)) {
        watchedSlides.add(el);
        new MutationObserver(function () { if (el.isConnected) fixHiddenSlide(el); })
          .observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
      }
      fixHiddenSlide(el);
    }
    function watchJudgeRoot(root) {
      if (watchedJudgeRoots.has(root)) return;
      watchedJudgeRoots.add(root);
      // Some app versions append a generic node and add its slide class later. Only inspect the
      // changed element inside this widget, never all reviews or the document on carousel rotation.
      new MutationObserver(function (records) {
        var changed = new Set();
        records.forEach(function (record) {
          changed.add(record.target);
        });
        changed.forEach(function (el) { if (el.isConnected && el.matches('.jdgm-carousel-item')) watchSlide(el); });
      }).observe(root, { subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'class'] });
    }
    // HO-PERF: write an attribute only when its value changes. A same-value setAttribute still queues a DOM
    // mutation, and session-recording tags can inspect the page for each one.
    function setTabindex(el, v) { if (el.getAttribute('tabindex') !== v) el.setAttribute('tabindex', v); }
    function ensureEmptyCart(d) {
      var content = d.querySelector('.mini-cart__content');
      var tmpl = d.querySelector('#ho-mini-cart-empty-tmpl') || document.getElementById('ho-mini-cart-empty-tmpl');
      if (!content || !tmpl || !tmpl.content) return;
      if (content.querySelector('.cart-item, .cart-items-container, .mini-cart--empty')) return;
      content.appendChild(tmpl.content.cloneNode(true));
    }
    function fixDrawer(d) {
      if (!d || !d.isConnected) return;
      ensureEmptyCart(d);
      // Strip aria-hidden (drawer + inner form). It conflicts with the cart's focusable content
      // (axe "aria-hidden contains focusable"). Hide the CLOSED state with inert instead. Detect
      // OPEN by the `open` class (the theme toggles that, not aria-hidden).
      if (d.hasAttribute('aria-hidden')) d.removeAttribute('aria-hidden');
      d.querySelectorAll('form').forEach(function (f) {
        if (!watchedForms.has(f)) {
          watchedForms.add(f);
          new MutationObserver(function () {
            if (f.isConnected && f.closest('#mini-cart') && f.hasAttribute('aria-hidden')) f.removeAttribute('aria-hidden');
          }).observe(f, { attributes: true, attributeFilter: ['aria-hidden'] });
        }
        if (f.hasAttribute('aria-hidden')) f.removeAttribute('aria-hidden');
      });
      var open = d.classList.contains('open');
      if (open) {
        if (d.hasAttribute('inert')) d.removeAttribute('inert');
        d.querySelectorAll('a, button, summary, input, select, textarea').forEach(function (el) { setTabindex(el, '0'); });
        // HO-PERF: the closed drawer's mascot icons are rendered with data-src (component-order-summary,
        // in_drawer) so they don't download on every page; load them on open. Also inflate the deferred
        // wallets here, for adds that bypass fetch and for bfcache restores.
        d.querySelectorAll('img[data-src]').forEach(function (i) { i.src = i.getAttribute('data-src'); i.removeAttribute('data-src'); });
        if (window.hoInflateWallets) window.hoInflateWallets();
      } else {
        if (!d.hasAttribute('inert')) d.setAttribute('inert', '');
        d.querySelectorAll('a, button, summary, input, select, textarea').forEach(function (el) { setTabindex(el, '-1'); });
      }
    }
    function watchDrawer(d) {
      if (!watchedDrawers.has(d)) {
        watchedDrawers.add(d);
        new MutationObserver(function () { fixDrawer(d); })
          .observe(d, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
      }
      fixDrawer(d);
    }
    function fixIframeTitle(f) {
      if (f.hasAttribute('title')) return;
      var known = f.id === 'merchantwidgetiframe';
      if (!known) {
        try {
          var src = new URL(f.getAttribute('src') || '', document.baseURI);
          var google = src.hostname === 'google.com' || src.hostname.slice(-11) === '.google.com';
          known = google && (src.hostname === 'merchantverse.google.com' || /^\/(?:shopping|merchantverse)(?:\/|$)/.test(src.pathname));
        } catch (e) {}
      }
      if (known) f.setAttribute('title', 'Google customer reviews');
    }
    function watchFrame(f) {
      if (!watchedFrames.has(f)) {
        watchedFrames.add(f);
        new MutationObserver(function () { if (f.isConnected) fixIframeTitle(f); })
          .observe(f, { attributes: true, attributeFilter: ['src', 'id', 'title'] });
      }
      fixIframeTitle(f);
    }
    function visit(el) {
      if (el.matches('swiper-container, .swiper')) watchSwiper(el);
      if (el.matches(controls)) watchControl(el);
      if (el.matches('.jdgm-carousel-item')) watchSlide(el);
      if (el.matches(judgeRoots)) watchJudgeRoot(el);
      if (el.matches('iframe')) watchFrame(el);
      if (el.id === 'mini-cart') watchDrawer(el);
      if (el.id === 'ho-mini-cart-empty-tmpl') fixDrawer(document.getElementById('mini-cart'));
    }
    function discover(scope) {
      if (scope.nodeType === 1) visit(scope);
      scope.querySelectorAll(candidates).forEach(visit);
    }
    function start() {
      new MutationObserver(function (records) {
        var added = new Set(), drawers = new Set(), swipers = new Set();
        records.forEach(function (record) {
          var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          var d = target && target.closest('#mini-cart');
          var c = target && target.closest('swiper-container, .swiper');
          if (d) drawers.add(d);
          if (c) swipers.add(c);
          record.addedNodes.forEach(function (node) { if (node.nodeType === 1 && node.isConnected) added.add(node); });
        });
        added.forEach(function (node) {
          // A section and its descendants can arrive in the same delivery; inspect its subtree once.
          for (var parent = node.parentElement; parent; parent = parent.parentElement) if (added.has(parent)) return;
          discover(node);
        });
        drawers.forEach(fixDrawer);
        swipers.forEach(function (c) { if (c.isConnected) fixSwiperScope(c); });
      }).observe(document.documentElement, { childList: true, subtree: true });
      discover(document);
      ['shopify:section:load', 'shopify:section:reorder'].forEach(function (name) {
        document.addEventListener(name, function (event) { if (event.target.nodeType === 1) discover(event.target); });
      });
      ['swiperinit', 'swiperafterinit'].forEach(function (name) {
        document.addEventListener(name, function (event) {
          if (event.target.nodeType === 1) fixSwiperScope(event.target.closest('.shopify-section') || event.target);
        }, true);
      });
      window.addEventListener('pageshow', function (event) { if (event.persisted) discover(document); });
    }
    if (document.readyState !== 'loading') start();
    else document.addEventListener('DOMContentLoaded', start, { once: true });
  })();
} catch (e) { if (window.console) console.error(e); }

/* 3. Megamenu grid layout safeguard (re-applies grid if an inline style overrides it). */
try {
  document.addEventListener('DOMContentLoaded', function () {
    var menu = document.querySelector('.nav__main-menu--one_level_megamenu');
    if (!menu) return;

    function fixMenuLayout() {
      // A same-value style assignment still queues attribute mutations. Avoid
      // feeding this observer back into itself when the menu layout is correct.
      if (menu.style.gridTemplateColumns !== 'repeat(auto-fill, minmax(180px, 1fr))') {
        menu.style.gridTemplateColumns = 'repeat(auto-fill, minmax(180px, 1fr))';
      }
      if (menu.style.gap !== '20px 40px') menu.style.gap = '20px 40px';
    }

    fixMenuLayout();

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'style') fixMenuLayout();
      });
    });
    observer.observe(menu, { attributes: true, attributeFilter: ['style'] });
  });
} catch (e) { if (window.console) console.error(e); }

/* 4. Free-shipping progress: threshold pulled from theme settings (was hard-coded 499).
  HO-PERF: no /cart.js fetch of its own any more. #amount-left is already server-rendered, so the page-load fetch
  (one uncacheable request on every page view) is gone, and after a cart change the single cart:updated handler in
  the next script passes its /cart.js response to hoUpdateFreeShipping(). Amount and format now match
  component-order-summary: threshold - cart.total_price (cart-level discounts included), money_without_trailing_zeros
  ("$499", not "$499.00"), or money_with_currency when the theme shows currency codes. */
try {
  (function () {
    var freeShippingThreshold = window.hoFreeShippingThreshold || 0; // Liquid: settings.threshold_free_shipping (snippets/ho-custom-head.liquid)
    var withCurrency = !!window.hoDisplayCurrency; // Liquid: settings.display_currency (snippets/ho-custom-head.liquid)

    function money(cents) {
      var s = (cents / 100).toFixed(2), i = s.indexOf('.');
      return s.slice(0, i).replace(/\B(?=(\d{3})+$)/g, ',') + s.slice(i);
    }

    window.hoUpdateFreeShipping = function (cart) {
      if (!freeShippingThreshold || !cart) return;
      var amountElement = document.getElementById('amount-left');
      if (!amountElement) return;
      var cents = Math.max(0, Math.round(freeShippingThreshold * 100) - (cart.total_price || 0));
      var label = withCurrency
        ? '$' + money(cents) + ' ' + (cart.currency || '')
        : '$' + money(cents).replace(/\.00$/, '');
      if (amountElement.textContent !== label) amountElement.textContent = label;
    };
  })();
} catch (e) { if (window.console) console.error(e); }

/* 5. HO-CUSTOM: make the `cart:updated` event REAL, and sync the drawer
  "Secure checkout" button off it.

  Root cause found by live instrumentation: NOTHING in the theme ever dispatches
  `cart:updated`. It is a dead event: the free-shipping updater above listens for it
  (so the progress bar only refreshed when base.js happened to re-render that section:
  the "bar appears randomly" bug), and the first version of this checkout fix listened
  for it too (so the button stayed disabled after an AJAX add: the "can't click Secure
  checkout from the drawer until I change page" bug: #checkout is server-rendered
  `disabled` when the cart is empty at page load and the add path re-renders the item
  list but not the summary button).

  Fix in three parts:
  1. Wrap window.fetch once: after any successful cart mutation
     (/cart/add|change|update|clear), dispatch `cart:updated` (debounced 50ms so a
     burst of section fetches produces one event). Every existing and future listener
     now actually fires on every cart change, whichever component triggered it.
  2. The shared __hoAtc WeakSet in the theme bundles binds each quick-add form once.
     Do not deduplicate fetches by body or elapsed time: two deliberate rapid adds
     can have identical bodies, and Request objects can carry different bodies.
  3. Listen for cart:updated and sync every checkout button's disabled state to the
     live cart item_count (querySelectorAll covers cart page + drawer). HO-PERF: that one
     /cart.js response also updates the free-shipping text and inflates the deferred
     drawer wallets; a pageshow handler refreshes a stale cart after a bfcache restore. */
try {
  (function () {
    var CART_MUTATION = /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/;
    var origFetch = window.fetch;
    var pending = null;

    window.fetch = function () {
      var input = arguments[0];
      var init = arguments[1];
      var url;
      try { url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href); }
      catch (e) { return origFetch.apply(this, arguments); }
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (url.origin !== window.location.origin || method !== 'POST' || !CART_MUTATION.test(url.pathname)) {
        return origFetch.apply(this, arguments);
      }
      // The theme's shared __hoAtc WeakSet prevents duplicate submit bindings.
      // Forward each actual mutation once: a time-window fetch dedupe also
      // swallowed deliberate rapid additions with identical quantities.
      var p = origFetch.apply(this, arguments);
      p.then(function (res) {
        if (res && res.ok) {
          clearTimeout(pending);
          pending = setTimeout(function () {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }, 50);
        }
      }).catch(function () {});
      return p;
    };

    function syncCheckoutButtons(count) {
      var enabled = count > 0;
      document.querySelectorAll('button[name="checkout"], #checkout').forEach(function (btn) {
        if (enabled) {
          if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
        } else if (!btn.hasAttribute('disabled')) {
          btn.setAttribute('disabled', '');
        }
      });
    }

    // HO-PERF: an empty cart drawer ships its express-checkout wallets inside an inert
    // <template data-ho-wallets> (component-order-summary), so landing pages no longer pull ~80 KB of
    // wallet JS while the page is loading. Swap the template for its content once the cart has items or
    // the drawer opens; Shopify's own observer then starts the buttons. replaceWith = never twice.
    function hoInflateWallets() {
      document.querySelectorAll('template[data-ho-wallets]').forEach(function (t) { t.replaceWith(t.content.cloneNode(true)); });
    }
    window.hoInflateWallets = hoInflateWallets;

    // HO-PERF: ONE /cart.js per cart change (the free-shipping updater used to fetch it again, plus once on
    // every page load) feeds the checkout buttons, the free-shipping text and the wallets.
    // The sessionStorage stamp records "the cart changed in this tab" for the bfcache check below.
    var HK = 'hoCartV', hoSeen = null;
    var cartRefresh = 0;
    try { hoSeen = sessionStorage.getItem(HK); } catch (e) {}
    document.addEventListener('cart:updated', function (ev) {
      var refresh = ++cartRefresh;
      if (!(ev.detail && ev.detail.bfcache)) {
        try { hoSeen = String(Date.now()); sessionStorage.setItem(HK, hoSeen); } catch (e) {}
      }
      var cartRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      origFetch(cartRoot + 'cart.js')
        .then(function (r) { if (!r.ok) throw new Error('Cart refresh failed'); return r.json(); })
        .then(function (cart) {
          if (refresh !== cartRefresh) return;
          syncCheckoutButtons(cart.item_count);
          if (window.hoUpdateFreeShipping) window.hoUpdateFreeShipping(cart);
          if (cart.item_count > 0) hoInflateWallets();
        })
        .catch(function () {});
    });

    // HO-PERF: back/forward cache. Going back (e.g. PDP -> collection) restores the old page instantly with
    // zero bytes, but with the cart as it was. If the cart changed elsewhere in this tab (stamp moved) or
    // the page is over 30 min old, re-render the drawer + badges once; updateMiniCart() with no argument
    // never opens the drawer. No request otherwise. Keep pages bfcache-eligible: no page-teardown listeners.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || typeof window.updateMiniCart !== 'function') return;
      var now = null;
      try { now = sessionStorage.getItem(HK); } catch (x) {}
      if (now === hoSeen && Date.now() - performance.timeOrigin < 18e5) return;
      hoSeen = now;
      Promise.resolve(window.updateMiniCart()).then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { bfcache: true } }));
      }).catch(function () {});
    });
  })();
} catch (e) { if (window.console) console.error(e); }

/* 6. "Spin to win" launcher: opens the PopSpin app modal from any [href="#spin-to-win"] link. */
try {
  document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="#spin-to-win"]');
      if (!link) return;
      e.preventDefault();
      if (window.PopSpin && typeof window.PopSpin.open === 'function') {
        window.PopSpin.open();
        return;
      }
      var modal = document.querySelector('.ca-sw-modal-overlay, .ca-sw-modal-content');
      if (modal) {
        modal.style.display = 'block';
        modal.removeAttribute('hidden');
      }
    });
  });
} catch (e) { if (window.console) console.error(e); }

/* 7. Variant-selects guard: on product cards WITHOUT variant images (single-image
  products, e.g. coco perlite), the theme's updateMedia() queries
  #gallery-<id> (the swiper) which doesn't exist on those cards and throws
  "Cannot read properties of null (reading 'dataset')". That exception aborts
  onVariantChange BEFORE renderProductInfo() (price) and updateAddToCart()
  (button) run, so selecting a variant didn't update the price or button.
  Skip updateMedia when there's no gallery; everything else proceeds. */
try {
  (function () {
    function patchVariantSelects() {
      var ctor = window.customElements && customElements.get('variant-selects');
      if (!ctor || ctor.prototype.__hoMediaGuard) return;
      ctor.prototype.__hoMediaGuard = true;

      var originalUpdateMedia = ctor.prototype.updateMedia;
      ctor.prototype.updateMedia = function () {
        try {
          if (!document.querySelector('#gallery-' + this.uniqueIdentifier)) return;
        } catch (e) {
          return;
        }
        return originalUpdateMedia.apply(this, arguments);
      };

      // Re-apply Back-Order / Pre-Order button labels, the leaf stock badge and
      // the discount % badge for the selected variant. The theme's
      // updateAddToCart only knows add/sold-out and re-renders only the price.
      //
      // Scope to the CARD this variant-selects lives in (this.closest('.card')).
      // The earlier `.form-product-<uniqueIdentifier>` match only worked on the
      // collection-page card fork; the homepage featured-collection base card
      // wires its block id differently, so that selector matched nothing and the
      // badge/button never updated. A card-scoped lookup works for every card
      // layout. On the product page (no .card) we fall back to the form match.
      var originalUpdateAddToCart = ctor.prototype.updateAddToCart;
      ctor.prototype.updateAddToCart = function () {
        var ret = originalUpdateAddToCart ? originalUpdateAddToCart.apply(this, arguments) : undefined;
        try {
          var self = this;
          var vid = this.currentVariant && this.currentVariant.id;
          if (!vid) return ret;

          var scopes = [];
          var ownCard = this.closest && this.closest('.card');
          if (ownCard) {
            scopes.push(ownCard);
          } else {
            document.querySelectorAll('.form-product-' + this.uniqueIdentifier).forEach(function (f) { scopes.push(f); });
          }

          scopes.forEach(function (scope) {
            var mapEl = scope.querySelector('.ho-stock-map');
            if (!mapEl) return;
            var status;
            try { status = JSON.parse(mapEl.textContent)[vid]; } catch (e) { return; }

            var btn = scope.querySelector('[name="add"]');
            var span = scope.querySelector('[name="add"] > span:not(.cart-icon)');
            if (btn && span) {
              if (status === 'preorder') { btn.removeAttribute('disabled'); span.textContent = 'Pre-Order'; }
              else if (status === 'backorder') { btn.removeAttribute('disabled'); span.textContent = 'Back-Order'; }
              // Ships direct from the supplier: the theme's own "Add to cart" (also on cards the theme's
              // updateAddToCart does not reach), never a Back-Order label left by an earlier variant.
              else if (status === 'direct') { btn.removeAttribute('disabled'); span.textContent = (window.cartStrings && window.cartStrings.addToCart) || 'Add to cart'; }
              /* instock / soldout keep the theme's default label */
            }

            // Quick-add icon: hourglass (back-order) / calendar (pre-order) / cart (ships direct, in stock).
            // HO-PERF: byte-identical to the Liquid-rendered icons (component-form-product, component-icon,
            // component-stock-status) so a swap reuses the cached file instead of fetching a second copy.
            var qaIcon = scope.querySelector('[name="add"] [data-ho-qa-icon]');
            if (qaIcon) {
              if (status === 'preorder') qaIcon.src = '/cdn/shop/files/Calendar_Mascot.png?v=1781610394&width=120';
              else if (status === 'backorder') qaIcon.src = '/cdn/shop/files/Hourglass_Mascot.png?v=1781608997&width=120';
              else qaIcon.src = '/cdn/shop/files/Cart_Mascot.png?v=1750647480&width=120';
            }

            // Back-order / pre-order / ships-direct cart line-item property (tags the order). Set the
            // name only for special variants: an input with no name is not submitted,
            // so in-stock variants are never tagged. (Was the rex-preorder block.)
            var preProp = scope.querySelector('[data-ho-preorder-prop]');
            if (preProp) {
              if (status === 'preorder' || status === 'backorder' || status === 'direct') {
                preProp.setAttribute('name', 'properties[' + preProp.getAttribute('data-ho-pre-name') + ']');
                preProp.value = preProp.getAttribute('data-ho-pre-value') || '';
              } else {
                preProp.removeAttribute('name');
              }
            }

            var card = scope.classList && scope.classList.contains('card') ? scope : (scope.closest && scope.closest('.card'));

            // Card: badge lives in the card. Product page (no card): badge is the
            // leaf badge over the main gallery image (.ho-pdp-media) in this section.
            var badge = card ? card.querySelector('[data-ho-leaf-badge]') : null;
            if (!badge) {
              var sec = self.closest && self.closest('.shopify-section');
              if (sec) badge = sec.querySelector('.ho-pdp-media [data-ho-leaf-badge]');
            }
            if (badge) {
              var txt = badge.querySelector('[data-ho-leaf-text]');
              badge.classList.remove('ho-leaf-badge--pre-order', 'ho-leaf-badge--back-order');
              if (status === 'preorder') { if (txt) txt.textContent = 'Pre-Order'; badge.classList.add('ho-leaf-badge--pre-order'); badge.hidden = false; badge.style.display = ''; }
              else if (status === 'backorder') { if (txt) txt.textContent = 'Back-Order'; badge.classList.add('ho-leaf-badge--back-order'); badge.hidden = false; badge.style.display = ''; }
              else { badge.hidden = true; badge.style.display = 'none'; } /* direct (ships direct), instock, soldout: no badge */
            }

            // Back-order / pre-order / ships-direct dispatch notice (product page only). Show it only
            // for special variants; Liquid already wrote its words for this product.
            // The notice lives in this section, outside the form.
            var preSec = self.closest && self.closest('.shopify-section');
            var preNotice = preSec && preSec.querySelector('[data-ho-preorder-notice]');
            if (preNotice) {
              var preSpecial = (status === 'preorder' || status === 'backorder' || status === 'direct');
              preNotice.hidden = !preSpecial;
              preNotice.style.display = preSpecial ? '' : 'none';
            }

            // Update the top-right discount % badge for the selected variant
            // (the theme only re-renders the price, not the badge).
            if (card) {
              var cv = self.currentVariant;
              var cap = cv && cv.compare_at_price, pp = cv && cv.price;
              var pct = (cap && pp && cap > pp) ? Math.round((cap - pp) * 100 / cap) : 0;
              var dBadge = card.querySelector('.card__badge--discount');
              if (pct >= 1) {
                if (!dBadge) {
                  dBadge = document.createElement('a');
                  dBadge.className = 'card__badge card__badge--on-sale card__badge--discount';
                  var plink = card.querySelector('a[href*="/products/"]');
                  if (plink) dBadge.setAttribute('href', plink.getAttribute('href'));
                  card.insertBefore(dBadge, card.firstChild);
                }
                dBadge.textContent = '-' + pct + '%';
                var titleEl = card.querySelector('.card__title, .card__heading, a[href*="/products/"]');
                var pTitle = titleEl ? titleEl.textContent.trim() : '';
                dBadge.setAttribute('aria-label', pct + '% off' + (pTitle ? ' ' + pTitle : ''));
                dBadge.hidden = false;
                dBadge.style.display = '';
              } else if (dBadge) {
                dBadge.hidden = true;
                dBadge.style.display = 'none';
              }
            }
          });
        } catch (e) {}
        return ret;
      };
    }
    if (window.customElements && customElements.get('variant-selects')) {
      patchVariantSelects();
    } else if (window.customElements) {
      customElements.whenDefined('variant-selects').then(patchVariantSelects);
    }
  })();

  // HO-PERF: custom.css keeps a card slider's hidden (variant) slide images from downloading
  // (.card:not(.ho-warm)). On the first touch or focus inside a card's variant pills, mark that card
  // .ho-warm so its variant image starts loading just before the change instead of after it.
  (function () {
    function hoWarm(e) {
      var v = e.target && e.target.closest && e.target.closest('.card variant-selects');
      if (!v) return;
      var c = v.closest('.card');
      if (c && !c.classList.contains('ho-warm')) c.classList.add('ho-warm');
    }
    document.addEventListener('pointerdown', hoWarm, { capture: true, passive: true });
    document.addEventListener('focusin', hoWarm, true);
  })();
} catch (e) { if (window.console) console.error(e); }

/* 8. HO-CUSTOM: keep the back-order / pre-order / ships-direct dispatch ETA fresh (today + lead days) even if the page HTML was edge-cached, matching the former rex-preorder client-side computation. The day is counted in the shop's time zone (Australia/Hobart) in calendar days, the same way the Merchant Center feed computes availability_date; a visitor's or crawler's own clock would show a different day for part of each day. */
try {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ho-preorder-notice]').forEach(function (n) {
      var lead = parseInt(n.getAttribute('data-ho-lead-days'), 10);
      if (isNaN(lead)) return;
      var eta = n.querySelector('.ho-preorder-notice__eta');
      if (!eta) return;
      var s;
      try {
        var t = {};
        new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Hobart', year: 'numeric', month: 'numeric', day: 'numeric' })
          .formatToParts(new Date()).forEach(function (x) { t[x.type] = x.value; });
        s = new Date(Date.UTC(+t.year, +t.month - 1, +t.day + lead, 12))
          .toLocaleDateString('en-AU', { day: 'numeric', month: 'long', timeZone: 'UTC' });
      }
      catch (e) { s = 'approximately ' + lead + ' days'; }
      var label = 'Estimated dispatch around ' + s + '.';
      if (eta.textContent !== label) eta.textContent = label;
    });
  });
} catch (e) { if (window.console) console.error(e); }

/* 9. Emoji -> branded mascot image replacement in body text (duplicate keys removed).
  HO-PERF: mascots come from the store domain at 96 px (2x the <=48 px display; was 150 from cdn.shopify.com), lazy +
  async-decoded, and replacements only touch eligible text nodes that contain one of the emoji. It used to escape
  every text node on the page, including <script>/<style> text: it even rewrote its own replacement table, which
  injected all 8 mascots (about 54 KB, never shown) into every page. */
try {
  document.addEventListener('DOMContentLoaded', function () {
    var replacements = {
      '🌿': '<img class="ho-emoji-mascot" src="/cdn/shop/files/Leaf_Mascot.png?v=1781656448&width=96" alt="Hydro Oasis Leaf Icon" width="96" height="96" loading="lazy" decoding="async">',
      '🌱': '<img class="ho-emoji-mascot" src="/cdn/shop/files/Soil_Seedling_Mascot.png?width=96" alt="Hydro Oasis Seedling Icon" width="96" height="96" loading="lazy" decoding="async">',
      '🪴': '<img class="ho-emoji-mascot" src="/cdn/shop/files/LECA_Seedling_Mascot.png?width=96" alt="Hydro Oasis Pot Icon" width="96" height="96" loading="lazy" decoding="async">',
      '🧪': '<img class="ho-emoji-mascot" src="/cdn/shop/files/Analysis_Mascot.png?width=96" alt="Hydro Oasis Analysis Icon" width="96" height="96" loading="lazy" decoding="async">',
      '💧': '<img class="ho-emoji-mascot" src="/cdn/shop/files/Water_Droplet_Mascot.png?width=96" alt="Hydro Oasis Water Droplet Icon" width="96" height="96" loading="lazy" decoding="async">',
      '💡': '<img class="ho-emoji-mascot" src="/cdn/shop/files/Light_Bulb_Mascot.png?width=96" alt="Hydro Oasis Light Bulb Icon" width="96" height="96" loading="lazy" decoding="async">',
      '🔧': '<img class="ho-emoji-mascot" src="/cdn/shop/files/Spanner_Mascot.png?width=96" alt="Hydro Oasis Spanner Icon" width="96" height="96" loading="lazy" decoding="async">',
      '🌼': '<img class="ho-emoji-mascot" src="/cdn/shop/files/Flower_Mascot.png?width=96" alt="Hydro Oasis Flower Icon" width="96" height="96" loading="lazy" decoding="async">'
    };

    function escapeHtml(str) {
      return str
        .split('&').join('&amp;')
        .split('<').join('&lt;')
        .split('>').join('&gt;')
        .split('"').join('&quot;')
        .split("'").join('&#39;');
    }

    // One pass: never text inside script/style/etc. (case-insensitive: SVG <style>/<title> are lowercase), and
    // only nodes that contain an emoji (one regex test) go on to the escape-and-replace loop below.
    var RX = new RegExp(Object.keys(replacements).join('|'), 'u');
    // One native read keeps pages without matching emoji out of the traversal.
    if (!RX.test(document.body.textContent)) return;
    var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|TITLE|OPTION|TEMPLATE)$/i;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        // Skip emoji-free branches with a native read instead of visiting every text node.
        // Keep the text node's immediate-parent exclusions below for mixed SVG/custom DOM.
        if (n.nodeType === Node.ELEMENT_NODE) {
          return RX.test(n.textContent) ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_REJECT;
        }
        var p = n.parentNode;
        if (!p || SKIP.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
        return RX.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach(function (node) {
      // Escape the original text first so only the trusted <img> markup below is
      // ever parsed as HTML; emoji chars are unaffected by escaping, so the
      // substitutions still match. (& must be escaped before < and >.)
      var replaced = escapeHtml(node.nodeValue);
      var needsReplacement = false;
      for (var emoji in replacements) {
        if (replaced.indexOf(emoji) !== -1) {
          replaced = replaced.split(emoji).join(replacements[emoji]);
          needsReplacement = true;
        }
      }
      if (needsReplacement) {
        var span = document.createElement('span');
        span.innerHTML = replaced;
        node.parentNode.replaceChild(span, node);
      }
    });
  });
} catch (e) { if (window.console) console.error(e); }
